import Styled from "styled-components";

export const Form = Styled.form`

`;

export const H1 = Styled.h1`

`;

export const ContainerCadastro = Styled.div`

`;

export const Input = Styled.input`

`;

export const Text = Styled.div`

`;

export const Line = Styled.div`

`;

export const RegisterNewAddress = Styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .registerNewAddressHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }
`;

export const Registration = Styled.p`

`;

export const ContainerInput = Styled.div`

`;

export const Label = Styled.label`

`;

export const InputIEnjoy = Styled.input`

`;

export const InputLarge = Styled.input`

`;

export const ContainerInputDate = Styled.div`

`;

export const InputDate = Styled.input`

`;

export const InputMask = Styled.input`

`;

export const ConfirmAndCancel = Styled.div`
display: flex;
align-items: center;
gap: 8px;
  .cancel{
    color: #B00020;
  }
`;

export const Principal = Styled.div`

`;

export const RegisteredCards = Styled.div`

`;

export const CheckboxContainer = Styled.div`

`;

export const Radio = Styled.input`

`;

export const FormContainer = Styled.div`
  .form-address__input {
    color: ${props => props.theme.whitelabel?.theme?.text_primary_color} !important;
    border-bottom: 1px solid ${props => props.theme.whitelabel?.theme?.text_primary_color} !important;
    
    &:focus {
      border-bottom-color: ${props => props.theme.whitelabel?.theme?.text_primary_color} !important;
    }
  }
`;